import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { UnitProvider } from "@/context/UnitContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import AppShell from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Incidents from "@/pages/Incidents";
import Compliance from "@/pages/Compliance";
import Documents from "@/pages/Documents";
import Assistant from "@/pages/Assistant";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST, synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell><Dashboard /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/incidents"
        element={
          <ProtectedRoute>
            <AppShell><Incidents /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/compliance"
        element={
          <ProtectedRoute>
            <AppShell><Compliance /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/documents"
        element={
          <ProtectedRoute>
            <AppShell><Documents /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/assistant"
        element={
          <ProtectedRoute>
            <AppShell><Assistant /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/knowledge"
        element={
          <ProtectedRoute>
            <AppShell><KnowledgeBase /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/reports"
        element={
          <ProtectedRoute>
            <AppShell><Reports /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/settings"
        element={
          <ProtectedRoute>
            <AppShell><Settings /></AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <UnitProvider>
            <AuthProvider>
              <AppRouter />
              <Toaster position="top-right" />
            </AuthProvider>
          </UnitProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
